import { TextField, TextFieldProps } from '@mui/material'
import { useState } from 'react'
import { formatFormInputCurrencyString, formatFormInputCurrencyStringLenient } from '../../utils/currencyFormatter'
import { parseCurrencyString } from '../../utils/currencyParser'

type Props = {
  onChange: (value?: number) => void
  value?: number
} & Omit<TextFieldProps, 'onChange' | 'value'>
export default function POAmountInput(props: Props) {
  const { onChange, value, ...passedProps } = props
  const [inputValue, setInputValue] = useState<string>(
    typeof value !== 'undefined' ? formatFormInputCurrencyString(value.toString()) || '' : '',
  )

  const handleAmountChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    e.preventDefault()
    const v = formatFormInputCurrencyStringLenient(e.target.value)
    setInputValue(v)
    if (v === '') {
      onChange(undefined)
      return
    }
    const n = parseCurrencyString(v)
    if (Number.isNaN(n)) {
      return
    }
    onChange(n)
  }
  const handleAmountBlur: React.FocusEventHandler<HTMLInputElement> = (e) => {
    const v = e.target.value.replace(/[^0-9\,.]/g, '')
    if (v === '') {
      onChange(undefined)
      return
    }
    const n = parseCurrencyString(v)
    if (Number.isNaN(n)) {
      return
    }
    const formatted = formatFormInputCurrencyString(v)
    if (!formatted) return
    setInputValue(formatted)
    onChange(n)
  }
  return (
    <TextField
      fullWidth
      slotProps={{ input: { startAdornment: '$' } }}
      sx={{ minWidth: '12em' }}
      {...passedProps}
      value={inputValue}
      onChange={handleAmountChange}
      onBlur={handleAmountBlur}
    />
  )
}
